import gql from 'graphql-tag'

export const LIST_PROFILE_RULES = gql`
  query ListProfileRule($limit: Int!, $offset: Int!, $userIds: [ID!], $profileId: Float!, $orderBy: String!) {
    listUserRules(user: $userIds, orderBy: $orderBy) {
      results(limit: $limit, offset: $offset) {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        profile(id: $profileId) {
          id
        }       
        ruleUserTable {
          owner {
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      totalCount
    }
  }
`

export const LIST_GROUP_RULES = gql`
  query ListProfileRule($limit: Int!, $offset: Int!, $userIds: [ID!], $groupId: Float!, $orderBy: String!) {
    listUserRules(user: $userIds, orderBy: $orderBy) {
      results(limit: $limit, offset: $offset) {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        group(id: $groupId) {
          id
        }       
        ruleUserTable {
          owner {
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      totalCount
    }
  }
`

export const LIST_CATEGORY_RULES = gql`
  query ListProfileRule($limit: Int!, $offset: Int!, $userIds: [ID!], $categoryId: Float!, $orderBy: String!) {
    listUserRules(user: $userIds, orderBy: $orderBy) {
      results(limit: $limit, offset: $offset) {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        category(id: $categoryId) {
          id
        }       
        ruleUserTable {
          owner {
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      totalCount
    }
  }
`

export const LIST_INTEREST_RULES = gql`
  query ListProfileRule($limit: Int!, $offset: Int!, $userIds: [ID!], $interestId: Float!, $orderBy: String!) {
    listUserRules(user: $userIds, orderBy: $orderBy) {
      results(limit: $limit, offset: $offset) {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        interest(id: $interestId) {
          id
        }       
        ruleUserTable {
          owner {
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      totalCount
    }
  }
`

export const CREATE_PROFILE_RULE = gql`
  mutation CreateProfileRule($ruleData: RuleCreateInput!) {
    createRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        profile {
          id
        }
        ruleUserTable {
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const CREATE_GROUP_RULE = gql`
  mutation CreateGroupRule($ruleData: RuleCreateInput!) {
    createRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        group {
          id
        }
        ruleUserTable {
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const CREATE_CATEGORY_RULE = gql`
  mutation CreateCategoryRule($ruleData: RuleCreateInput!) {
    createRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        category {
          id
        }
        ruleUserTable {
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const CREATE_INTEREST_RULE = gql`
  mutation CreateInterestRule($ruleData: RuleCreateInput!) {
    createRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        interest {
          id
        }
        ruleUserTable {
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const UPDATE_PROFILE_RULE = gql`
  mutation UpdateProfileRule($ruleData: RuleUpdateInput!) {
    updateRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        profile{
          id
        }
        ruleUserTable{
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const UPDATE_GROUP_RULE = gql`
  mutation UpdateGroupRule($ruleData: RuleUpdateInput!) {
    updateRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        group{
          id
        }
        ruleUserTable{
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const UPDATE_CATEGORY_RULE = gql`
  mutation UpdateCategoryRule($ruleData: RuleUpdateInput!) {
    updateRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        category{
          id
        }
        ruleUserTable{
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const UPDATE_INTEREST_RULE = gql`
  mutation UpdateInterestRule($ruleData: RuleUpdateInput!) {
    updateRule(ruleData: $ruleData) {
      rule {
        id
        name
        ruleType
        repeated
        applyToNew
        applyToAll
        frequency
        applyToBirthday
        remindDays
        skipContactedWithin
        timeZone
        scheduledDateTime
        interest{
          id
        }
        ruleUserTable{
          owner{
            id
          }
        }
        ruleMessage {
          id
          body
        }
      }
      success
      message
    }
  }
`

export const DELETE_RULE = gql`
  mutation DeleteRule($ruleData: RuleDeleteInput!) {
    deleteRule(ruleData: $ruleData) {
      rule {
        id
      }
      success
      message
      profileIds
    }
  }
`

export const DELETE_MESSAGE = gql`
  mutation DeleteMessage($messageData: RuleMessageDeleteInput!) {
    deleteRuleMessage(messageData: $messageData){
      ruleMessage{
        id
      }
      success
      message      
    }
  }
`
